import { render, staticRenderFns } from "./AwlLoader.vue?vue&type=template&id=09c44ff8&"
import script from "./AwlLoader.vue?vue&type=script&lang=js&"
export * from "./AwlLoader.vue?vue&type=script&lang=js&"
import style0 from "./AwlLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports